<template>
  <section class="page-container">
    <div class="total">
      <div
        v-for="(value,i) in statistics"
        :key="i"
        class="item">
        <span class="num">{{value.val}}</span>
        <span>{{value.name}}</span>
      </div>
    </div>

    <div class="filter-card">
      <div class="filter-top">
        <span>Search</span>
        <v-input
          v-model="search"
          placeholder="Ref., Customer Name, Phone No."
          @keyEnter="filterData" />
      </div>
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="changeDate" />
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template>
            <div class="flex-algin">
              <font-awesome-icon
                icon="sack-dollar"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Purchased">
          <template #default="{row}">
            <p>{{row.created_date}}</p>
            <p>{{row.created_time}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="Product Name">
          <template #default="{row}">
            <div>
              <router-link
                :to="clickProductName(row)"
                class="no-line">
                <p class="product-name">{{row.plan}}</p>
                <p class="ref"><span>Reference</span>{{row.order_sn}}</p>
              </router-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Price"
          prop="amount">
        </el-table-column>
        <el-table-column
          label="Customer">
          <template #default="{row}">
            <div>
              <p>{{row.isrd_nm}}</p>
              <p>{{row.mobile_no}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <p>
                <span class="span-status green">
                  {{ row.status_language }}
                </span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getGiftPackList} from '@/api/micropolicy'
export default {
  name: 'PurchaseList',
  data () {
    return {
      search: null,
      date: [],
      tableData:[],
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      statistics:{
        total: {
          name: 'Total Gift Packs',
          val: 0
        }
      }
    }
  },
  created(){
    this.network().getList()
  },
  methods: {
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },

    filterData(){
      this.network().getList()
    },

    handlerDown() {
      // this.network().KFLMListExport()
    },

    rowClick(row){
      this.$router.push({
        path: '/records/micropolicy/purchase-detail',
        query: {
          giftId: row.id
        }
      })
    },

    clickProductName(row){
      return ({
        path: '/records/micropolicy/purchase-detail',
        query: {
          giftId: row.id
        }
      })
    },

    network(){
      return {
        getList: async () => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
          }
          const { data } = await getGiftPackList(params)
          this.pageConfig.currentPage = data.current_page
          this.pageConfig.total = data.total
          this.tableData = data.data
          this.statistics.total.val = data.total
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  .total{
    margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      .num{
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        padding: 0 10px;
      }
    }
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .filter-left {
        padding: 15px 0;
        width: 290px;
        min-width: 290px;
      }
    }
  }
  .transparent{
    .product-name{
      word-break: break-word;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
    }
    .ref{
      color: #6A737D;
      &>span{
        font-weight: 600;
        padding-right: 5px;
      }
    }
    .no-line{
      text-decoration: none;
      color: #606266;
    }
    .span-status {
      display: inline-block;
      padding: 1px 8px;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: #FFFFFF;
      border-radius: 100px;
      max-width: 140px;
      word-break:keep-all;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      .svg-inline--fa {
        margin-right: 5px;
        font-size: 14px;
      }
      &.green {
        background: #28a745;
        color: white;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  font-size: 12px;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
     .cell{
       //min-height: 40px;
       line-height: 18px;
       position: relative;
       height: inherit;
       //margin-left: 10px;
       //margin-right: 10px;
       padding: 0;
       //padding: 5px 10px;
       //position: absolute;
       //top: 10px;
     }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
</style>
